import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateProvider } from '@graphql/mutations'

function ManageProviderForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createProvider, { loading }] = useCreateProvider()

  const onFinish = data => {
    createProvider({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetProvidersQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do fornecedor" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar fornecedor
      </Button>
    </Form>
  )
}

ManageProviderForm.propTypes = {
  afterSubmit: func,
}

ManageProviderForm.defaultProps = {
  afterSubmit: null,
}

export default ManageProviderForm
